import analyticsIcon from "./analytics-01.png";
import cellsIcon from "./cells.png";
import chartIcon from "./chart-relationship.png";
import attachmentIcon from "./document-attachment.png";
import logoutIcon from "./logout-circle-01.png";
import plantIcon from "./plant-03.png";
import shoppingCart from "./shopping-cart-01.png";
import usersIcon from "./user-multiple.png";

export const Icons = {
  analyticsIcon,
  cellsIcon,
  chartIcon,
  attachmentIcon,
  logoutIcon,
  plantIcon,
  shoppingCart,
  usersIcon,
};
